import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({ name: 'voteTerm', pure: false })
export class VoteTermPipe implements PipeTransform {
  constructor(private ls: LocalizationService) {}

  transform(term: Date | number | null | undefined): string {
    if (term) {
      const diff = dayjs(term).diff(dayjs(), 'days');

      if (diff > 0) {
        return this.ls.trReplace('res.daysLeft', { $count: diff });
      } else if (diff < 0) {
        return this.ls.trReplace('res.voteEnded', { $count: -diff });
      } else {
        return this.ls.translate('res.tillToday');
      }
    } else return '';
  }
}
